//import fetch from "@/Helpers/fetch";
import {Result} from "@/Helpers/propertiesQueryResult";
import geohash from "ngeohash";

export const LISTINGS_API_URL = "/api/listings";

export const LISTINGS_SEARCH_API_URL = "/api/listings/search";

export const CITY_API_URL = "/api/city";


export const getApiUrl = (url) => {
    if(document.location.host.indexOf('localhost') > -1 || document.location.host.indexOf('realty-s7.com') > -1) {
        //return 'http://demo.realty-s7.com:8000' + url;
        return 'https://everyjerseyhome.realmotif.com' + url;
    }
    return "https://" + document.location.host + url;
}

export const getTotalByHash = (hash) => {
  const headers = new Headers();
  const url = "/properties/hash/total"
  let params = {
    "hash" : hash
  }

  return fetch(url, {headers}, params, false)
      .then((response) => response.json())
      .then((data) => {
        return data["items"]["hits"]["total"]["value"] ? data["items"]["hits"]["total"]["value"] : null;
  });
}

export const getProperties = (
  mls_agent_id = null,
  limit = 8,
  pageNum = 1,
  ne_lat= null,
  ne_lng= null,
  sw_lat= null,
  sw_lng= null,
  onlyActive = true,
  showFullTotal = false
) => {
    //console.log(mls_agent_id);
    const headers = new Headers();
    const url = "/realty_items"
    let params = {
      "limit" : limit,
      "page": pageNum
    }
    if(ne_lat) { params.ne_lat = ne_lat; }
    if(ne_lng) { params.ne_lng = ne_lng; }
    if(sw_lat) { params.sw_lat = sw_lat; }
    if(sw_lng) { params.sw_lng = sw_lng; }
    params.only_active = onlyActive;
    params.show_full_total = showFullTotal;
    if(mls_agent_id) {params.mls_agent_id = mls_agent_id;}
    return fetch(url, {headers}, params, false)
    .then((response) => response.json())
    .then((data) => {
      const result = {};
      result["hits"] = data["items"]["hits"]["hits"];
      result["total"] =  data["items"]["hits"]["total"]["value"];
      result["page"] = pageNum;
      return result;
    });
}

export async function getPropertyDetail(
                                 mld_listing_id) {
  const headers = new Headers();
  const url = "/properties/" + mld_listing_id
  let params = {

  }
  const response = await fetch(url, {headers}, params, false);
  const data = await response.json();
  if(data["items"]["hits"]["total"]["value"] && data["items"]["hits"]["total"]["value"] > 0) {
    return data["items"]["hits"]["hits"][0]['_source'];
  }
  return null;
}

export const getProperty = (
  mls,
  mld_listing_id
) => {
  const headers = new Headers();
  const url = "/realty_items/" + mld_listing_id
  let params = {
    "mls" : mls
  }
  return fetch(url, {headers}, params, false)
    .then((response) => response.json())
    .then((data) => {
      if(data["items"]["hits"]["total"]["value"] && data["items"]["hits"]["total"]["value"] > 0) {
        return data["items"]["hits"]["hits"][0];
      }
      return null;
    });
}

/**
 * @param {Query} query
 */
export const getPropertiesByQuery = (
    query
) => {
    const url = new URL(getApiUrl(LISTINGS_API_URL));
    let params = query.getPayload();
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    return fetch(url, params)
        .then((response) => response.json())
        .then((data) => {
            const result = new Result();

            result.items = data["items"]["hits"]["hits"];
            if(
              data["items"]["aggregations"] &&
              data["items"]["aggregations"]["zoomed"]
            ) {
              const aggregations = data["items"]["aggregations"]["zoomed"]["zoom"]["buckets"];
             // let sw_lat = 200, sw_lng = 200, ne_lat = - 100, ne_lng = - 100;
              result.geo_hash = [];
              for (let index in aggregations) {
                const box = geohash.decode_bbox(aggregations[index].key);
                result.geo_hash.unshift(
                  {
                    box: box,
                    count: aggregations[index].doc_count,
                     lat: (box[0] + box[2]) / 2,
                     lng: (box[1] + box[3]) / 2,
                    // radius: (box[0] + box[2]) / 2,
                  }
                );
                // ne_lat = ne_lat > box[2] ? ne_lat : box[2];
                // ne_lng = ne_lng > box[3] ? ne_lng : box[3];
                // sw_lat = sw_lat < box[0] ? sw_lat : box[0];
                // sw_lng = sw_lng < box[1] ? sw_lng : box[1];
              }
              // if(aggregations.length > 0) {
              //   result.bounds = [sw_lat, sw_lng, ne_lat, ne_lng];
              // }
            }
            result.total =  data["items"]["hits"]["total"]["value"];
            result.pageNum = query.page;
            //console.log(result);
            return result;
        })
        .catch(() => {
          //
            const result = new Result();
            result.items = [];
            result.total =  0;
            result.pageNum = query.page;
            return result;
        });

}

/**
 * @param {String} city
 */
export const getCityById = (
  city
) => {
  const headers = new Headers();
  const url =  getApiUrl(CITY_API_URL + '/' + city)  //"/cities/"+ city

  return fetch(url, {headers})
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
}

export const getFieldGroups = () => {
  const headers = new Headers();
  const url = "/field/groups"
  let params = {
  }
  return fetch(url, {headers}, params, false)
    .then((response) => response.json())
    .then((data) => {
      if(data["groups"]) {
        return data["groups"];
      }
      return null;
    });
}



export const getRealtor = (
  id
) => {
  const headers = new Headers();
  const url = "/realtors/" + id
  let params = {
  }
  return fetch(url, {headers}, params, false)
    .then((response) => response.json())
    .then((data) => {
      if(data["id"]) {
        return data;
      }
      return null;
    });
}

export const getSiteRealtors = (
  site_id,
  limit = 20,
  pageNum = 1
) => {
  const headers = new Headers();
  const url = "/site_realtors";
  //site_realtors?page=1&pagination=false&site.id=16
  let params = {
    "limit" : limit,
    "page": pageNum,
    "pagination" : "false",
    "site.id" : site_id
  }

  return fetch(url, {headers}, params, false)
    .then((response) => response.json())
    .then((data) => {
      const result = {};
      result["hits"] = data["hydra:member"];
      result["total"] =  data["hydra:totalItems"];
      result["page"] = pageNum;
      return result;
    });
}



